import styled from 'styled-components';

const HeroSectionStyle = styled.section`
	--titleDescDistance: var(--sp5x);
	--heroImageProportion: 28.2%;

	--innerOuterWrapperPadBottom: var(--sp15x);

	--gridTemplateColumns: 5fr 7fr;

	--arrowsWidth: fit-content;
	--arrowsHeight: 65vw;
	--arrowsLeft: 0;
	--arrowsTop: -100%;

	position: relative;

	.arrows {
		position: absolute;
		top: 100%;
		left: var(--arrowsLeft);
		width: var(--arrowsWidth);
		height: var(--arrowsHeight);
		z-index: -1;
	}

	.hero-inner-content {
		display: flex;
		align-items: flex-end;
	}

	.hero-image {
		--proportion: var(--heroImageProportion);
	}

	.inner-outer-wrapper {
		padding-bottom: var(--innerOuterWrapperPadBottom);
	}

	.hero-inner-section {
		position: relative;

		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: linear-gradient(90deg, #8b1c30 31.08%, rgba(37, 7, 13, 0) 142.02%);
			z-index: 2;
		}
	}

	.hero-content {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 3;

		padding: 0 var(--contPaddingLR);
	}

	.top-block {
		display: grid;
		grid-template-columns: var(--gridTemplateColumns);
		gap: var(--gutter);
		height: 100%;
	}

	.hero-desc {
		margin-top: var(--titleDescDistance);

		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 7;
		overflow: hidden;
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--titleDescDistance: var(--sp4x);

		--innerOuterWrapperPadBottom: var(--sp12x);

		--gridTemplateColumns: 6fr 6fr;

		--heroImageProportion: 29.5%;
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--titleDescDistance: var(--sp3x);

		--innerOuterWrapperPadBottom: var(--sp11x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--titleDescDistance: var(--sp3x);

		--innerOuterWrapperPadBottom: var(--sp10x);

		--gridTemplateColumns: 5fr 7fr;
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--titleDescDistance: var(--sp2x);

		--innerOuterWrapperPadBottom: var(--sp8x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--titleDescDistance: var(--sp2x);
		--heroImageProportion: 29.4%;

		--innerOuterWrapperPadBottom: var(--sp5x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--titleDescDistance: var(--sp2x);
		--heroImageProportion: 38.3%;

		--innerOuterWrapperPadBottom: var(--sp5x);

		--gridTemplateColumns: 6fr 6fr;

		--arrowsHeight: 100vw;
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--titleDescDistance: var(--sp2x);
		--heroImageProportion: 116.4%;

		--innerOuterWrapperPadBottom: var(--sp4x);

		--gridTemplateColumns: 1fr;

		.empty-col {
			display: none;
		}
	}
`;

export default HeroSectionStyle;
